"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ensureNoEndSlash(p) {
    return p.replace(/\/$/, "");
}
exports.default = ensureNoEndSlash;
